import { z } from "zod";
import { Frequency, RRule } from "rrule";

export const EnableGlobalReportSchema = z.object({
  freq: z.string(),
  byhour: z.number().min(0).max(23),
  interval: z.number().min(1),
});

export const defaultEnableGlobalReportValues = {
  freq: Frequency.WEEKLY.toString(),
  interval: 1,
  byhour: 9,
} as const;

export type EnableGlobalReportForm = z.infer<typeof EnableGlobalReportSchema>;

export const REPORT_MINUTE = 0;
export const REPORT_SECOND = 0;
export const REPORT_WEEKLY_DAY = RRule.MO;
export const REPORT_MONTHLY_DAY = 1;

export const formToRRule = (form: EnableGlobalReportForm) => {
  const freq = parseInt(form.freq);
  const byweekday = freq === Frequency.WEEKLY ? REPORT_WEEKLY_DAY : undefined;
  const bymonthday =
    freq === Frequency.MONTHLY ? REPORT_MONTHLY_DAY : undefined;

  return new RRule({
    freq: parseInt(form.freq),
    interval: form.interval,
    byhour: form.byhour,
    byminute: REPORT_MINUTE,
    bysecond: REPORT_SECOND,
    dtstart: new Date(),
    byweekday,
    bymonthday,
  });
};

export const getDefaultGlobalReportFrequency = () =>
  new RRule({
    ...defaultEnableGlobalReportValues,
    freq: RRule.WEEKLY,
    dtstart: new Date(),
    byminute: REPORT_MINUTE,
    bysecond: REPORT_SECOND,
    byweekday: REPORT_WEEKLY_DAY,
  }).toString();
